// @flow

import * as React from 'react';
import classnames from 'classnames';
import styles from './styles.scss';

import { mouseEnter } from '../../utils/animation';
import type { PlaceType } from '../../api/types';

type Props = {
  places: Array<PlaceType>,
  currentPlace: PlaceType,
  setCurrentPlace: (currentPlace: PlaceType) => void,
};

const ContactData = (props: Props): React.Element<any> => {
  const handleClick = (name: string) => {
    const place = props.places.find(place => place.name === name);

    if (place) {
      props.setCurrentPlace(place);
    }
  };

  return (
    <React.Fragment>
      <div className={styles['form-title-container']}>
        <h3 className={styles['form-title']}>Contact Us</h3>
        <div className={styles['pay-online-btn-container']}>
          <div className="btn" data-animation="fadeInRight">
            <a href="https://centerstaging.securepayments.cardpointe.com/pay" target="_blank" rel="noopener noreferrer">
              <span>Pay Online</span>
            </a>
          </div>
        </div>
      </div>
      <div className={styles.cities}>
        <div
          className={classnames(styles.city, {
            current: !props.currentPlace.name || props.currentPlace.name === 'Los Angeles',
          })}
        >
          <div className={styles['city-name']} onClick={() => handleClick('Los Angeles')}>
            <span onMouseEnter={mouseEnter}>Los Angeles</span>
          </div>
          <p className={styles['address-title']}>Artist's Campus</p>
          <p>3406 Winona Ave, Burbank,</p>
          <p className={styles.bottom}>
            CA 91504
            <a
              href="https://www.google.com/maps/place/CenterStaging/@34.199339,-118.3486227,17z/data=!4m13!1m7!3m6!1s0x80c295a9ecc3090b:0xee45b67fff74c452!2zMzQwNyBXaW5vbmEgQXZlLCBCdXJiYW5rLCBDQSA5MTUwNCwg0KHQqNCQ!3b1!8m2!3d34.1997614!4d-118.3476102!3m4!1s0x80c295a9ea94c7d7:0x4f757560d7863421!8m2!3d34.1997644!4d-118.3475982"
              target="_blank"
              rel="noopener noreferrer"
            >
              View map
            </a>
          </p>

          <p className={styles['address-title']}>Rental Will Call</p>
          <p>2517 N. Ontario St, Burbank</p>
          <p className={styles.bottom}>
            CA 91504
            <a
              href="https://www.google.com.ua/maps/place/CenterStaging/@34.1982554,-118.3469148,18z/data=!4m13!1m7!3m6!1s0x80c2950794674c8d:0x53267a557bedab03!2s2517+N+Ontario+St,+Burbank,+CA+91504,+USA!3b1!8m2!3d34.1975499!4d-118.3449621!3m4!1s0x80c2950794731859:0x6899f25c0b55fc56!8m2!3d34.1975499!4d-118.3449621"
              target="_blank"
              rel="noopener noreferrer"
            >
              View map
            </a>
          </p>

          <p className={styles.phone}>
            <a href="tel:8185594333">(818) 559-4333</a> <span>fax: (818) 848-4016</span>
          </p>
        </div>
        <div className={classnames(styles.city, { current: props.currentPlace.name === 'New York' })}>
          <div className={styles['city-name']} onClick={() => handleClick('New York')}>
            <span onMouseEnter={mouseEnter}>New York</span>
          </div>

          <p className={styles['address-title']}>Rental Will Call</p>
          <p className={styles.phone}>
            <a href="tel:2126511290">(212) 651-1290</a>
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactData;



// WEBPACK FOOTER //
// ./src/components/Contact/Data.js